import React from "react";
import {ThemeProvider as ChakraThemeProvider, CSSReset, DefaultTheme} from "@chakra-ui/core";
import {Global, css} from "@emotion/core";

import defaultTheme from "./theme";

interface Props {
  theme?: DefaultTheme;
}

const ThemeProvider: React.FC<Props> = ({children, theme = defaultTheme}) => {
  return (
    <ChakraThemeProvider theme={theme}>
      <CSSReset />
      <Global
        styles={css`
          * {
            touch-action: manipulation;
            font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
              "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
          }
        `}
      />
      {children}
    </ChakraThemeProvider>
  );
};

export default ThemeProvider;
